module.exports = __webpack_public_path__ + "static/media/PIJL_01.a743c3f5.png";